import { objectKeys } from "@/utils/ts-utils"
import { useTheme, useToken } from "@chakra-ui/react"
import { useCallback, useMemo } from "react"

type Color = { [color: string]: string | number | Color }

const parseThemeColors = (colors: Color, prefix?: string) => {
  const c = []
  for (const colorName of objectKeys(colors ?? {})) {
    if (typeof colors[colorName] === "object") {
      const cName = `${prefix ?? ""}${colorName}.`
      const cNames = parseThemeColors(colors[colorName] as Color, cName)
      cNames.map(cn => c.push(cn))
    } else c.push(`${prefix ?? ""}${colorName}`)
  }
  return c
}

export const useThemeColors = () => {
  const theme = useTheme()

  const colorNames = useMemo(() => parseThemeColors(theme.colors), [theme])
  const colorValues = useToken("colors", colorNames)

  const themeColors = useMemo(() => {
    const themeColors = {} as Record<string, string | number>
    for (let a = 0; a < colorNames.length; a++)
      themeColors[colorNames[a] as string] = colorValues[a] as string | number

    return themeColors
  }, [colorNames, colorValues])

  const getThemeColor = useCallback(
    (colorName: string, fallback?: string | number) => {
      return themeColors[colorName] ?? fallback
    },
    [themeColors]
  )

  return { getThemeColor, themeColors }
}
